import { render, staticRenderFns } from "./InstanceTypeList.vue?vue&type=template&id=07fb24e6&"
import script from "./InstanceTypeList.vue?vue&type=script&lang=js&"
export * from "./InstanceTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports